"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataHooks = exports.sizesMap = exports.Skin = exports.Size = void 0;
var Size = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
exports.Size = Size;
var Skin = {
  standard: 'standard',
  premium: 'premium',
  success: 'success'
};
exports.Skin = Skin;
var sizesMap = {
  small: 30,
  medium: 54,
  large: 102
};
exports.sizesMap = sizesMap;
var dataHooks = {
  tooltip: 'circular-progressbar-tooltip',
  circularProgressBar: 'circular-progress-bar',
  errorIcon: 'error-icon',
  successIcon: 'success-icon'
};
exports.dataHooks = dataHooks;